import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import { useRouter } from 'hooks/useRouter';
import { useCallback } from 'react';
import { useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';
import { ERROR_TOAST_DEFAULTS } from '@helpers';

export const useFetchNOM151 = (documentName: string | null = null) => {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
  });

  const { query } = useRouter();

  const { teamId, folderId, documentId } = query;

  const toast = useToast();

  const { t } = useTranslation();

  const callback = useCallback(async () => {
    const response = await client.fetchDocumentNOM151(
      teamId as string,
      folderId as string,
      documentId as string,
    );

    const a = window.document.createElement('a');
    a.href = URL.createObjectURL(response?.data);
    a.download = `${documentName} - CINCEL.asn1`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    return response;
  }, [client, documentId, folderId, teamId, documentName]);

  const onError = useCallback(async () => {
    const msg = t(translations.ERRORS.NOM_ERROR);
    toast({ ...ERROR_TOAST_DEFAULTS, title: msg });
  }, [t, toast]);

  const fn = useQuery(
    ['fetch-nom-151', teamId, folderId, documentId],
    callback,
    {
      enabled: false,
      onError,
      retry: 0,
    },
  );

  return { ...fn };
};
